export default {
    init() {
        $('.js-team-carousel').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            autoplay: false,
            adaptiveHeight: false,
            appendArrows: $('.team-members__controls'),
        });

        $('.js-services-carousel').slick({
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            autoplay: false,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                      infinite: false,
                        slidesToShow: 3,
                        slidesToScroll: 2,
                      dots: true,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                      infinite: true,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                      dots: true,
                    },
                },
                {
                    breakpoint: 576,
                    settings: {
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                      dots: true,
                    },
                },
            ],
        });

        $('.js-tabs-carousel').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            autoplay: true,
            adaptiveHeight: false,
            centerMode: true,
            infinite: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });

        if ($('.js-services-carousel .slick-slide').length > 4) {
            $('.js-services-carousel').slick('slickSetOption', {
                dots: true,
            }, true);
        }

        $('body').bind('copy cut drag drop', function (e) {
            e.preventDefault();
        });
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js